import moment from "moment-timezone"
import { DELETE_FILE } from "../repository/common_repo"
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
// this function return required error'sand required select.
export const requiredMessage = (name) => {
  return `Please enter ${name}`
}
export const requiredSelect = (name) => {
  return `Please select ${name}`
}
export const requiredDate = (name) => {
  return `Please choose ${name}`
}

export function getColors(count) {
  const colors = [
    'rgb(120, 198, 195)', 'rgb(222, 177, 153)', 'rgb(171, 229, 198)',
    'rgb(136, 240, 234)', 'rgb(249, 208, 255)', 'rgb(190, 157, 161)',
    'rgb(218, 157, 197)', 'rgb(213, 236, 118)', 'rgb(171, 243, 235)',
    'rgb(248, 103, 206)', 'rgb(220, 176, 254)', 'rgb(135, 212, 245)',
    'rgb(178, 189, 172)', 'rgb(210, 254, 146)', 'rgb(100, 245, 108)',
    'rgb(184, 221, 222)', 'rgb(204, 253, 130)', 'rgb(170, 242, 140)',
    'rgb(231, 191, 217)', 'rgb(125, 176, 230)', 'rgb(236, 233, 187)',
    'rgb(175, 252, 151)', 'rgb(106, 163, 135)', 'rgb(132, 235, 202)',
    'rgb(196, 193, 186)', 'rgb(182, 134, 104)', 'rgb(152, 220, 153)',
    'rgb(211, 219, 113)', 'rgb(181, 181, 212)', 'rgb(187, 162, 220)',
    'rgb(136, 213, 163)', 'rgb(196, 145, 113)', 'rgb(251, 185, 180)',
    'rgb(136, 214, 210)', 'rgb(248, 237, 142)', 'rgb(150, 182, 148)',
    'rgb(123, 159, 224)', 'rgb(135, 158, 170)', 'rgb(106, 255, 132)',
    'rgb(173, 158, 119)', 'rgb(244, 181, 119)', 'rgb(236, 220, 180)',
    'rgb(183, 174, 230)', 'rgb(155, 223, 158)', 'rgb(251, 137, 158)',
    'rgb(173, 234, 105)', 'rgb(176, 126, 246)', 'rgb(240, 253, 111)',
    'rgb(183, 249, 178)', 'rgb(191, 155, 148)', 'rgb(186, 225, 177)',
    'rgb(173, 212, 151)', 'rgb(220, 148, 114)', 'rgb(108, 217, 115)',
    'rgb(148, 100, 188)', 'rgb(253, 167, 140)', 'rgb(230, 250, 144)',
    'rgb(126, 140, 209)', 'rgb(199, 109, 218)', 'rgb(135, 161, 250)',
    'rgb(145, 231, 252)', 'rgb(189, 225, 180)', 'rgb(187, 235, 121)',
    'rgb(234, 119, 122)', 'rgb(141, 146, 187)', 'rgb(143, 138, 179)',
    'rgb(162, 160, 134)', 'rgb(174, 132, 126)', 'rgb(233, 179, 111)',
    'rgb(116, 241, 213)', 'rgb(154, 203, 187)', 'rgb(118, 116, 185)',
    'rgb(130, 184, 211)', 'rgb(231, 130, 152)', 'rgb(177, 120, 182)',
    'rgb(252, 249, 140)', 'rgb(194, 233, 207)', 'rgb(221, 227, 230)',
    'rgb(208, 244, 198)', 'rgb(249, 105, 181)', 'rgb(154, 208, 187)',
    'rgb(180, 107, 173)', 'rgb(211, 254, 141)', 'rgb(218, 156, 200)',
    'rgb(208, 154, 186)', 'rgb(101, 109, 205)', 'rgb(210, 213, 243)',
    'rgb(235, 194, 162)', 'rgb(222, 232, 167)', 'rgb(182, 187, 105)',
    'rgb(145, 133, 219)', 'rgb(255, 220, 121)', 'rgb(164, 148, 168)',
    'rgb(252, 143, 135)', 'rgb(104, 221, 255)', 'rgb(187, 177, 245)',
    'rgb(231, 226, 100)', 'rgb(130, 234, 179)', 'rgb(142, 156, 121)',
    'rgb(176, 178, 196)'
  ]
  // for (let i = 0; i < count; i++) {
  //   const r = Math.floor(Math.random() * 156) + 100;
  //   const g = Math.floor(Math.random() * 156) + 100;
  //   const b = Math.floor(Math.random() * 156) + 100;
  //   colors.push(`rgb(${r}, ${g}, ${b})`);
  // }
  let sliceData = colors?.slice(0, count)

  return sliceData;
}

export const handleListPagination = (list, getListMethod, controller, setController) => {
  if (list?.length === 1) {
    if (controller.page === 1) {
      getListMethod();
    } else {
      setController((prev) => ({ ...prev, page: Math.max(controller.page - 1, 1) }));
    }
  } else {
    getListMethod();
  }
};
export const isDetails = (value) => {
  return value || "-";
};

export const formatedDate = (date = null, format = "ll") => {
  return moment(date).format(format)
}
// capitalize First Letter
export function capitalizeFirstLetter(string = "") {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1)
}


export const onSort = (columnKey = null, sortConfig, setSortConfig) => {
  let direction = -1;
  if (sortConfig.sortValue === columnKey) {
    direction = sortConfig.sortOrder === 1 ? -1 : 1;
  }
  setSortConfig((prev) => ({
    ...prev,
    sortValue: columnKey,
    sortOrder: direction,

  }));
};
export const handleTrimmedValue = (value = "") => {
  // Check if the value is a string and completely empty after trimming
  const isTrimmedEmpty = typeof value === "string" && value?.trim()?.length === 0;

  // Return the trimmed value only if it's completely empty; otherwise, return as-is
  return isTrimmedEmpty ? value?.trim() : value;
};

export const removeFile = async ({
  type = "SOFTDELETE",        // Action type: SOFTDELETE, DISCARD_HARD_DELETE, SUBMIT_HARD_DELETE
  getImages = [],             // Images to compare for deletion
  imagePath = "defaultPath",  // File path for the images
  setAllImage = () => { },     // Setter to update all deleted images
  allImage = [],              // Array of all deleted images
  setImage = () => { },        // Setter to update the currently uploaded image
  Images = null,              // The uploaded image to be deleted
  setLoader = () => { },       // Loader to indicate API call
} = {}) => {
  const getImageArray = Array.isArray(getImages) ? getImages : [getImages];
  let storedImages = [...allImage]; // Create a copy of all deleted images

  if (type === "SOFTDELETE") {
    // For soft delete: backup current image and reset
    setAllImage((prev) => [...prev, Images]);

    if (Array.isArray(getImages)) {
      setImage((prev) => prev.filter((img) => img !== Images)); // For arrays
    } else {
      setImage(null); // For single images
    }
    return;
  }

  let imageForDeletion = [];

  if (type === "DISCARD_HARD_DELETE") {
    // Discard images matching `getImages` and include `Images` in deletion
    storedImages = storedImages.filter((item) => !getImageArray.includes(item));
    imageForDeletion = [...storedImages, Images];
  }

  if (type === "SUBMIT_HARD_DELETE") {
    // Remove `Images` from storedImages for submission
    imageForDeletion = storedImages.filter((item) => item !== Images);
    if (!storedImages.length) imageForDeletion = [Images];
  }

  // Ensure no falsy values exist in the deletion list
  imageForDeletion = imageForDeletion.filter(Boolean);

  if (!imageForDeletion.length) {
    console.log("No valid images to delete. Skipping API call.");
    return;
  }

  try {
    const payload = {
      fileName: imageForDeletion,
      type: imagePath,
    };
    setLoader(true);

    // Call API to delete images
    await DELETE_FILE(payload);

    // Update the attachment array or single image
    if (Array.isArray(getImages)) {
      setImage((prev) => prev.filter((img) => img !== Images)); // For arrays
    } else {
      setImage(null); // For single images
    }

    setAllImage([]);
  } catch (error) {
    console.error("Error deleting image:", error);
  } finally {
    setLoader(false);
  }
};

export const TIMEZONE = () => {
  if (timeZone === "Asia/Calcutta" || timeZone === "Asia/Kolkata") {
    let indiaTimezone = "Asia/Kolkata"
    return indiaTimezone
  } else {
    return timeZone
  }
}

export const getLocalizedText = (item, key, isEnglish) => {
  return isEnglish ? item?.[key] : item?.[`${key}_ar`] || item?.[key];
};

export const getFullAddress = (address = {}) => {
  const fieldsInOrder = [
    "buildingName",
    "appartmentNo",
    "floor",
    "street",
    "addionalDirection",
    "city",
    "country"
  ];

  const addressParts = fieldsInOrder
    .map(key => address?.[key])
    .filter(val => !!val?.toString().trim());

  return addressParts.length > 0 ? addressParts.join(", ") : "-";
};

// src/styles/muiTabStyles.js

export const tabStyles = (isDarkMode) => ({
  '& .MuiTab-root': {
    color: isDarkMode !== "light-mode" ? '#fff' : '#9c9d9d',
    fontWeight: 500,
  },
  '& .MuiTab-root.Mui-selected': {
    color: '#5CB1FF',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: "#5CB1FF",
  }
});
